// Nové mediální assety — B2G/B2B prezentace MLŽIDLA
// Všechna videa: autoplay / muted / loop / playsinline, poster = jpg

export const VIDEO_ASSETS = {
  // NEW HERO — promo pro městské ochlazování
  heroCityPromo: {
    src: 'https://videogen.vidiq.com/1f7c803a-a05c-4f80-8a0f-60f8fe0a9147/1d66c701-4c1b-4f99-8b1b-d09b3c699c3f_13447856395380036099.mp4.mp4',
    poster: '/media/optimized/518c8c2a3_mlzitka-pro-mesta.webp',
  },
  // V1 — Hero: BENDY na náměstí v Jičíně (18 s, 832×464)
  heroJicin: {
    src: 'https://base44.app/api/apps/6a96b2f0a9a77bed890bf313/files/mp/public/6a96b2f0a9a77bed890bf313/825fc9c6e_bendy_jicin_namesti_mlha.mp4',
    poster: '/media/optimized/774e88bcb_v2_jicin_bendy.webp',
  },
  // V2 — Montáž MLŽIDLA 2026 (18 s, 1280×720, s hudbou)
  montage2026: {
    src: 'https://base44.app/api/apps/6a96b2f0a9a77bed890bf313/files/mp/public/6a96b2f0a9a77bed890bf313/6ef6d8e60_mlzidla_montage_2026.mp4',
    poster: '/media/optimized/780206311_v3_montage_a.webp',
  },
  // V3 — Klip realizace (16 s, 1280×720)
  realizaceKlip: {
    src: 'https://base44.app/api/apps/6a96b2f0a9a77bed890bf313/files/mp/public/6a96b2f0a9a77bed890bf313/215781135_mlzidla_realizace_klip_720p.mp4',
    poster: '/media/optimized/f3ed5dc3f_v4_a.webp',
  },
  // V4 — Čtvercová smyčka 5 s (1080×1080, bez zvuku) — pro CTA pozadí
  loopSquare: {
    src: 'https://base44.app/api/apps/6a96b2f0a9a77bed890bf313/files/mp/public/6a96b2f0a9a77bed890bf313/8bae3b9b5_mlzidla_loop_1080sq.mp4',
    poster: '/media/optimized/f3ed5dc3f_v4_a.webp',
  },
};

// Klidná paleta BrandProfile
export const BRAND = {
  blue: '#0B5EA8',
  navy: '#0D2F4F',
  ice: '#EAF5FB',
  white: '#FFFFFF',
};

// BENDY slugy pro produktový detail
export const BENDY_SLUGS = ['mlzitko-bendy', 'bendy-60', 'bendy-alej', 'bendy-arc'];

// Skryj produkty s archivovaným nebo staženým slugem
const HIDDEN_PRODUCT_SLUGS = new Set([
  'bendy-field',
  'mlzitko-bendy-field',
  'mlzitko-mrak',
]);

export const isArchived = (slug) => {
  if (typeof slug !== 'string') return false;
  const normalized = slug.trim().toLowerCase();
  return normalized.startsWith('archived-') || HIDDEN_PRODUCT_SLUGS.has(normalized);
};